import { render, staticRenderFns } from "./ModalWizardGrupoGrade.vue?vue&type=template&id=71366a97&scoped=true"
import script from "./ModalWizardGrupoGrade.vue?vue&type=script&lang=js"
export * from "./ModalWizardGrupoGrade.vue?vue&type=script&lang=js"
import style0 from "./ModalWizardGrupoGrade.vue?vue&type=style&index=0&id=71366a97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71366a97",
  null
  
)

export default component.exports